<template>
  <Dropdown v-model="show" class="mr-3" class-prop="lg:w-100" mobile-title="Dates" :hide-on-click-outside="hideOnClickOutside">
    <template #button>
      <button
        ref="button"
        class="whitespace-nowrap rounded bg-gray-light p-3 font-medium hover:text-blue focus:outline-none"
        :class="{ 'text-blue': show || (filters.check_in && filters.check_out) }"
        @click="show = !show"
      >
        <span v-if="filters.check_in && filters.check_out">
          {{ $f.date(filterDate(filters.check_in), 'MMM D') }} - {{ $f.date(filterDate(filters.check_out), 'MMM D') }}
        </span>
        <span v-else>Check in - out</span>
      </button>
    </template>

    <DateRangePicker v-model="datesRange" />
  </Dropdown>
</template>

<script>
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { mapState } from 'pinia'
import Dropdown from '~/components/shared/Dropdown'
import DateRangePicker from '~/components/shared/DateRangePicker'
import { useVenuesStore } from '~/stores/venues'

dayjs.extend(customParseFormat)

export default {
  components: { Dropdown, DateRangePicker },

  props: {
    filters: { type: Object, required: true },
  },

  emits: ['update', 'apply'],

  data: () => ({
    show: false,
    datesRange: {
      startDate: null,
      endDate: null,
    },

    format: 'DD/MM/YYYY',
    minDate: dayjs(),
    hideOnClickOutside: true,
  }),

  computed: {
    ...mapState(useVenuesStore, {
      loading: s => s.totals.loading,
      total: s => s.totals.total,
    }),

    applyActive () {
      return this.datesRange.startDate && this.datesRange.endDate && ! this.loading
    },
  },

  watch: {
    datesRange: {
      deep: true,
      handler () {
        this.applyFilter()
      },
    },
  },

  mounted () {
    // this.$eventHub.on(`show-${this.$options._componentTag}`, () => {
    //   // A workaround to let dropdown stay when opened from the click outside dropdown component
    //   this.hideOnClickOutside = false
    //   this.show = true
    //   this.$scrollTo(this.$refs.button, { offset: -100 })
    //   setTimeout(() => (this.hideOnClickOutside = true), 100)
    // })
  },

  methods: {
    getFilterData () {
      return {
        check_in: this.datesRange.startDate ? dayjs(this.datesRange.startDate).format(this.format) : null,
        check_out: this.datesRange.endDate ? dayjs(this.datesRange.endDate).format(this.format) : null,
      }
    },

    applyFilter (hide = true) {
      this.updateValues(this.getFilterData())
      if (hide) {
        this.show = false
      }
    },

    updateTotals () {
      this.$emit('update', Object.assign({}, this.filters, this.getFilterData()))
    },

    clearFilter () {
      this.datesRange = { startDate: null, endDate: null }
      this.updateValues({ check_in: null, check_out: null })
      this.show = false
    },

    updateValues (values) {
      this.$emit('apply', Object.assign({}, values))
    },

    filterDate (string) {
      return dayjs(string, this.format)
    },
  },
}
</script>
